import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.community.group.info');
import { OnInit, OnDestroy, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ElementRef, ViewChild } from '@angular/core';
import ClassicEditor from "src/libs/portal/season/ckeditor/ckeditor";
import { Router } from '@angular/router'
import { marked } from 'marked';

@Component({
    selector: 'wiz-portal-gsdcadmin-community-group-info',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.community.group.info/view.scss */
/* src/app/portal.gsdcadmin.community.group.info/view.scss: no such file or directory */`],
})
export class PortalGsdcadminCommunityGroupInfoComponent implements OnInit, OnDestroy {
    @ViewChild('editor')
    public editorElement: ElementRef;
    public editor: any;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    @Input() community_id: any;
    @Input() group_id: any;
    public group: any = {};
    public community: any = {};
    public busy = false;
    public canDelete = false;
    public deletionPending = false;
    public get isNewGroup() { return !this.group?.id; }

    public async ngOnInit() {
        await this.service.init();
        if (await this.load()) await this.buildEditor();
    }

    private async request(action: string, values: any, keepBusy = false) {
        this.busy = true;
        this.service.loading.show();
        try {
            return await wiz.call(action, values, { timeout: 135000 });
        } catch (_) {
            return {code: 503, data: {message: "그룹 처리 결과를 확인하지 못했습니다. 같은 그룹으로 다시 시도해주세요."}};
        } finally {
            this.busy = keepBusy;
            this.service.loading.hide();
            await this.service.render();
        }
    }

    public async load() {
        const { code, data } = await this.request("load", { community_id: this.community_id, group_id: this.group_id });
        if (code !== 200) {
            await this.service.alert.error(data?.message || "그룹 정보를 불러오지 못했습니다.");
            if (code === 404) await this.router.navigate(['/admin/community', this.community_id, 'group']);
            return false;
        }
        this.group = data.group;
        this.community = data.community;
        this.canDelete = data.can_delete === true;
        this.deletionPending = data.deletion_pending === true;
        await this.service.render();
        return true;
    }

    public async buildEditor() {
        if (this.group.description == null) this.group.description = "";
        let editor = this.editor = await ClassicEditor.create(this.editorElement.nativeElement, {
            toolbar: {
                items: [
                    'undo', 'redo',
                    '|', 'heading',
                    '|', 'alignment:left', 'alignment:center', 'alignment:right', 'alignment:justify',
                    '|', 'bold', 'italic', 'strikethrough', 'underline',
                    '|', 'bulletedList', 'numberedList', 'outdent', 'indent',
                    '|', 'link', 'uploadImage', 'insertTable', 'blockQuote', 'codeBlock', 'horizontalLine'
                ],
                shouldNotGroupWhenFull: true
            },
            codeBlock: {
                languages: [
                    { language: 'plaintext', label: '평문' },
                    { language: 'c', label: 'C' },
                    { language: 'cpp', label: 'C++' },
                    { language: 'cs', label: 'C#' },
                    { language: 'css', label: 'CSS' },
                    { language: 'diff', label: 'Diff' },
                    { language: 'html', label: 'HTML' },
                    { language: 'java', label: 'Java' },
                    { language: 'javascript', label: 'JavaScript' },
                    { language: 'markdown', label: 'Markdown' }, // 여기서 Markdown 추가
                    { language: 'php', label: 'PHP' },
                    { language: 'python', label: 'Python' },
                    { language: 'ruby', label: 'Ruby' },
                    { language: 'typescript', label: 'TypeScript' },
                    { language: 'xml', label: 'XML' }
                ]
            },
            link: {
                addTargetToExternalLinks: true,
                defaultProtocol: 'https://',
            },
            removePlugins: ["MediaEmbedToolbar"],
            table: ClassicEditor.defaultConfig.table,
            simpleUpload: {
                uploadUrl: '/file/upload'
            }
        });
        this.editor.data.set(this.group.description);
    }

    public async ngOnDestroy() {
        if (this.editor) await this.editor.destroy();
    }

    public async update() {
        if (this.busy || this.deletionPending || this.isNewGroup || !this.editor) return;
        if (this.tab === 'text') await this.changeTab('editor');
        const {code, data} = await this.request('update', {
            id: this.group.id, description: this.editor?.getData() || ''
        });
        if (code !== 200) await this.service.alert.error(data?.message || "그룹 저장에 실패했습니다.");
        else await this.service.alert.success("저장되었습니다.");
    }

    public async delete() {
        if (this.busy || this.isNewGroup || !this.canDelete) return;
        this.busy = true;
        try {
            const confirmed = await this.service.alert.error("해당 연구그룹을 삭제하시겠습니까?", "취소", "삭제");
            if (!confirmed) return;
            const {code, data} = await this.request('delete', {id: this.group.id}, true);
            if (code !== 200) {
                if (data?.retry || code === 503) this.deletionPending = true;
                await this.service.alert.error(data?.message || "그룹 삭제를 완료하지 못했습니다. 다시 시도해주세요.");
            } else {
                this.canDelete = false;
                await this.service.alert.success(data?.message || "삭제되었습니다.");
                await this.router.navigate(['/admin/community', this.community.id, 'group']);
            }
        } finally {
            this.busy = false;
            await this.service.render();
        }
    }

    public async toggleGroupSetting(field: 'visible' | 'join_open', event?: Event) {
        event?.preventDefault();
        if (this.busy || this.deletionPending || this.isNewGroup) return;
        this.busy = true;
        try {
            const next = this.group[field] === 'N' ? 'Y' : 'N';
            const confirmed = await this.service.alert.show({
                message: field === 'visible' ? '그룹 공개 설정을 변경하시겠습니까?' : '가입 신청 허용 설정을 변경하시겠습니까?', action: '확인', cancel: '취소', status: 'warning'
            });
            if (confirmed !== true) return;
            const action = field === 'visible' ? 'toggleGroupVisible' : 'toggleGroupJoinOpen';
            const {code, data} = await this.request(action, {group_id: this.group.id, [field]: next}, true);
            if (code !== 200) await this.service.alert.error(data?.message || "그룹 저장에 실패했습니다.");
            else this.group[field] = next;
        } finally {
            this.busy = false;
            await this.service.render();
        }
    }

    public tab: 'editor' | 'text' = 'editor';

    public async changeTab(tab: 'editor' | 'text') {
        if (!this.editor) {
            this.tab = tab;
            await this.service.render();
            return;
        }

        if (this.tab === 'editor' && tab === 'text') this.group.description = this.editor.getData();
        if (this.tab === 'text' && tab === 'editor') this.editor.setData(this.group.description || '');

        this.tab = tab;
        await this.service.render();
    }
}

export default PortalGsdcadminCommunityGroupInfoComponent;